import { Nullable, PageViewModel, ServerResponse } from '@/types';

export enum SubmissionHistoryStatus {
  Created = 0,
  Reprocessed = 1,
  Failed = 2,
  Deleted = 3,
}

export enum UploadHistoryTableColumns {
  submissionId = 'submissionId',
  submissionDate = 'submissionDate',
  status = 'status',
  fileType = 'fileType',
  reason = 'reason',
  dataCollectionMethod = 'dataCollectionMethod',
  deletionDate = 'deletionDate',
}

export type UploadHistoryRow = {
  submissionId: number;
  submissionDate: string;
  deletionDate: Nullable<string>;
  status: SubmissionHistoryStatus;
  fileType: string;
  reason: Nullable<string>;
  dataCollectionMethod: Nullable<string>;
};

export type UploadHistoryData = {
  count: number;
  pageViewModel: PageViewModel;
  tableData: UploadHistoryRow[];
};

export type UploadHistoryResponse = ServerResponse<UploadHistoryData>;
